import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingFarmFootprintsByPrimaryDataIdAdmin, getFootprintingFarmPrimaryDataById } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_FARM_PRIMARY_DATA } from "consts";

export const useGetFootprintingFarmPrimaryDataById = (primaryDataId: string) => {
  const isAdmin = getEnvironment().admin; // TODO: Merge this with the Admin hook and use it to differentiate between the urls to call
  const queryClient = useQueryClient();

  return useQuery(
    {
      queryKey: [FOOTPRINTING_FARM_PRIMARY_DATA, primaryDataId, isAdmin],
      queryFn: async () => {
        if (primaryDataId === "") return;

        if (isAdmin) {
          return (await getFootprintingFarmFootprintsByPrimaryDataIdAdmin(primaryDataId)).footprint;
        }
        return getFootprintingFarmPrimaryDataById(primaryDataId);
      },
      enabled: !!primaryDataId && primaryDataId !== "",
      gcTime: 60000,
    },
    queryClient
  );
};
